import React from 'react';

import {
  faInfo
} from '@fortawesome/free-solid-svg-icons';
import {
  FontAwesomeIcon
} from '@fortawesome/react-fontawesome';

import {
  useTranslation
} from 'react-i18next';

import ToggleButton, {
  ToggleButtonProps
} from '@terrestris/react-geo/dist/Button/ToggleButton/ToggleButton';

export const ToggleFeatureInfoButton: React.FC<Partial<ToggleButtonProps>> = ({
  ...passThroughProps
}): JSX.Element => {

  const {
    t
  } = useTranslation();

  return (
    <ToggleButton
      className="toggle-feature-info-button"
      tooltip={t('ToggleFeatureInfoButton.tooltip')}
      tooltipProps={{
        mouseEnterDelay: 0.5
      }}
      pressedIcon={
        <FontAwesomeIcon
          icon={faInfo}
        />
      }
      icon={
        <FontAwesomeIcon
          icon={faInfo}
        />
      }
      {...passThroughProps}
    />
  );
};

export default ToggleFeatureInfoButton;
